import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../css/Hero.css";

import hero1 from "../assets/hero/halaman1.png";
import hero2 from "../assets/hero/halaman2.png";
import hero3 from "../assets/hero/halaman3.png";

const Hero = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true, // tombol kiri kanan
    pauseOnHover: false,
  };

  return (
    <section className="hero-section">
      <Slider {...settings}>
        <div className="hero-slide">
          <img src={hero1} alt="slide 1" className="hero-img" />
        </div>
        <div className="hero-slide">
          <img src={hero2} alt="slide 2" className="hero-img" />
        </div>
        <div className="hero-slide">
          <img src={hero3} alt="slide 3" className="hero-img" />
        </div>
      </Slider>
    </section>
  );
};

export default Hero;
